import { defer } from 'react-router-dom'
import { logger, getQueryStringParamsFromStringUrl } from '$utils'
import { isAppStateReady } from 'src/state/store'
import useTimeclockStore from '../store'
import { getDateRangeFromQueryStringOrAppStore } from '../../../../common/helpers/queryString'

export default async function loader({ request: { url } }) {
  const queryParams = getQueryStringParamsFromStringUrl(url)

  logger.debug(
    '[loader] About to await AppState being ready in PunchesByStaff loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in PunchesByStaff loader')

  const { startDateTime, endDateTime } =
    getDateRangeFromQueryStringOrAppStore(queryParams)

  const getTimeClockins = useTimeclockStore
    .getState()
    .getTimeClockins(startDateTime, endDateTime, false, false)

  const getStaffMembers = useTimeclockStore.getState().getStaffMembers()

  const getPackages = useTimeclockStore.getState().getPackages()

  return defer({
    data: Promise.all([getTimeClockins, getStaffMembers, getPackages])
      .then(() => true)
      .catch((error) => {
        logger.error('Punches By Staff Promise.all error', error)
        return false
      }),
  })
}
